import React, { Component } from 'react';
import {
  Divider,
  Form,
  Tab,
  Button,
  Modal,
  TextArea,
  Icon,
  Loader,
  Container,
  Checkbox
} from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { ChromePicker } from 'react-color';
import { toast } from 'react-toastify';
import omit from 'lodash/omit';
import find from 'lodash/find';
import maxBy from 'lodash/maxBy';
import sortBy from 'lodash/sortBy';

import * as AppActions from '../../actions';

import CardTab from './CardTab';
import PreviewList from './PreviewList';
import ModalForm from './ModalForm';
import './CanvasBuilder.css';
import CanvasTile from './CanvasTile';
import AssetGallery from '../../components/common/AssetGalleryV2/AssetGallery';
import buckets from '../../fileUploader/Buckets';

import { validateUrl } from './../../utils/validators';

import { getPages } from '../../fbApi/Page';

class CanvasBuilder extends Component {
  state = {
    page: null,
    canvasElement: 'Photo',
    fit: 'FitToWidth',
    fitVideo: 'FitToWidth',
    fitCarousel: 'FitToWidth',
    nextTab: 2,
    tabs: [],
    activeIndex: 0,
    editId: null,
    canvasElements: [],
    canvasElementsToDelete: [],
    log: [],
    showPreventMessage: false,
    operationResult: '',
    errorMessage: '',
    showModal: false,
    showModalColorPicker: false,
    showModalPendingChanges: false,
    canvasComponentId: null,
    canvasComponentType: null,
    componentToEdit: null,
    componentMessage: '',
    processing: false,
    form: {
      canvasName: '',
      theme: '#ffffff',
      enableSwipe: true,
      headline: '',
      copy: '',
      radioGroup: 'Photo',
      radioFit: 'FitToWidth',
      radioFitVideo: 'FitToWidth',
      radioFitCarousel: 'FitToWidth',
      photoName: '',
      imageUrl: '',
      imageTargetUrl: '',
      videoName: '',
      videoUrl: '',
      carouselName: '',
      cards: [{ cardName: '', cardImageUrl: '', cardTargetUrl: '' }],
      tiles: [{ name: '', asset: '', image_url: '' }]
    }
  };

  getPagesTest = async () => {
    const { getFbToken, user } = this.props;
    const token = getFbToken();
    const pages = await getPages(token, user.groups[0]);
    const filteredPages = pages[0].data.concat(pages[1].data).filter((page) => {
      return page.access_token;
    });
    // Change to another test account if necessary
    const selectedPage = find(filteredPages, (option) => {
      return option.name === 'Constellation Test';
    });
    return selectedPage;
  };

  selectedTab = (event, data) => {
    const index = data.activeIndex;
    this.setState({ activeIndex: index });
  };

  removeLastCard = (e) => {
    e.preventDefault();
    const form = this.state.form;
    let tabs = this.state.tabs;
    form.cards = form.cards.slice(0, -1);
    tabs = tabs.slice(0, -1);
    const nextTab = this.state.nextTab - 1;
    const activeIndex =
      this.state.activeIndex === 0 ? 0 : this.state.activeIndex - 1;
    this.setState({ tabs, form, nextTab, activeIndex });
  };

  renderTabContent = (index) => {
    return (
      <CardTab
        cardNumber={index + 1}
        handleCardChange={this.handleCardChange}
        card={this.state.form.cards[index]}
        getFbToken={this.props.getFbToken}
        onSelectAssetCard={this.onSelectAssetCard}
      />
    );
  };

  componentDidMount() {
    this.initializeTabs();

    if (this.props.canvasToEdit) {
      this.initializeEdit(this.props.canvasToEdit);
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.canvasToEdit) {
      this.initializeEdit(nextProps.canvasToEdit);
    }
  };

  initializeTabs = () => {
    const elem = this.renderTabContent(0);

    const tabs = [{ menuItem: 1, pane: { key: '1', content: elem } }];
    this.setState({ tabs });
  };

  onColorChange = ({ hex }) => {
    const { form } = this.state;
    const newForm = { ...form, theme: hex };

    this.setState((prevState) => ({
      ...prevState,
      form: newForm
    }));
  };

  onOpenColorPicker = (event) => {
    event.preventDefault();
    this.setState({ showModalColorPicker: true });
  };

  pickerClose = (event) => {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      showModalColorPicker: false
    }));
  };

  validateLastElementImage = () => {
    const lastElement = maxBy(this.state.canvasElements, (element) => {
      return element.order;
    });

    if (lastElement && lastElement.type === 'Photo') {
      return true;
    }

    return false;
  };

  initializeEdit = (canvasEdit) => {
    const { form } = this.state;
    const canvasObj = canvasEdit[0];
    const canvasTiles = canvasEdit.tiles || [];
    const { name, theme, headline, copy, enableSwipe } = canvasObj;
    const finalEnableSwipe =
      enableSwipe !== null && enableSwipe !== undefined ? enableSwipe : true;

    const newForm = form;
    newForm.canvasName = name;
    newForm.theme = theme;
    newForm.headline = headline;
    newForm.copy = copy;
    newForm.enableSwipe = finalEnableSwipe;

    const tiles = canvasTiles.map((tile) => ({
      id: tile.id,
      name: tile.name,
      asset: tile.asset,
      image_url: tile.image_url
    }));

    newForm.tiles =
      tiles.length > 0 ? tiles : [{ name: '', asset: '', image_url: '' }];

    this.setState({
      form: newForm,
      canvasElements: sortBy([...canvasEdit.canvasElements], 'order'),
      editId: canvasEdit[0].id
    });
  };

  addComponent = (e) => {
    e.preventDefault();
    this.setState({ componentMessage: '' });

    const form = this.state.form;

    const selectedAssetType = form.radioGroup;

    this.getAsset(form, selectedAssetType).then((asset) => {
      if (!asset) {
        const { cards } = form || {};
        // for validating carouse, since there is no data that we can use to identify the filetype of asset in cards,
        // loop through form.cards and check the fileextension in card.cardImageUrl.
        let errorMessage = 'Unknown error';
        switch (selectedAssetType.toLowerCase()) {
          case 'image':
            errorMessage = 'The Image Url is not valid or not accessible.';

            break;

          case 'video':
            errorMessage = 'The Video Url is not valid or not accessible.';
            break;

          case 'carousel':
            // if !asset is true, it means we have two cases to handle.
            //  1. at least one of the carousel card contains asset that is not image type
            //  2. at least one of the carousel card container invalid url.
            // we handle the 1 case for now.
            // TODO: handle all cases

            if (!cards || cards.length === 0) {
              errorMessage = 'No asset is selected for carousel.';
            } else if (!this.isValidCarouselCards(cards)) {
              errorMessage =
                'At least one of the carousel card has an asset that is not image. For Carousel, only image file type is valid.';
            } else {
              errorMessage = 'At least one of the Image Url is not valid';
            }
            break;

          default:
            break;
        }
        this.setState((prevState) => ({
          ...prevState,
          componentMessage: errorMessage
        }));

        return;
      }

      this.cleanCanvasElements();
      this.setState((prevState) => ({
        ...prevState,
        canvasElements: [...prevState.canvasElements, asset],
        showPreventMessage: true
      }));
    });
  };

  isValidCarouselCards = (cards) => {
    // empty and invalid cases are handled before.
    const invalidCards = cards.filter((card) => {
      const { cardImageUrl } = card || {};

      if (!cardImageUrl) return false;

      const split = cardImageUrl.split('.');
      const extension = split ? split.slice(-1) : [];

      return `${extension}` === 'mp4';
    });

    return invalidCards.length === 0;
  };

  editCanvasElement = (e) => {
    let id = '';
    let type = '';

    if (e.target.type) {
      id = e.target.id;
      type = e.target.type;
    } else {
      const idParts = e.target.id.split('-');
      id = idParts[0];
      type = idParts[1];
    }

    if (typeof id !== 'number') {
      // eslint-disable-next-line radix
      id = parseInt(id);
    }
    const canvasComponent = this.state.canvasElements.find(
      (canvas) => canvas.id === id && canvas.type === type
    );

    this.setState({
      showModal: true,
      canvasComponentId: id,
      canvasComponentType: type,
      componentToEdit: canvasComponent
    });
  };

  deleteCanvasElement = async (canvas, index) => {
    const canvasElementsToDelete = this.state.canvasElementsToDelete;
    canvasElementsToDelete.push(canvas.id);
    const canvasElements = this.state.canvasElements;
    canvasElements.splice(index, 1);
    this.setState({
      canvasElements,
      canvasElementsToDelete,
      showPreventMessage: true,
      log: []
    });
  };

  deletePhoto = async (canvasElementId) => {
    await this.props.deleteCanvasPhoto(canvasElementId);
  };

  deleteVideo = async (canvasElementId) => {
    await this.props.deleteCanvasVideo(canvasElementId);
  };

  deleteCarousel = async (canvas) => {
    await Promise.all(
      canvas.cards.map(async (card) => {
        await this.props.deleteCanvasCarouselCard(card.id);
        return Promise.resolve(card.id);
      })
    );

    await this.props.deleteCanvasCarousel(canvas.id);
    return Promise.resolve(canvas.id);
  };

  showPreventMessage = () => {
    this.setState({ showPreventMessage: true, log: [] });
  };

  /**
   * @param {object} form The form object.
   * @param {string} selectedAssetType This param can be Photo, Video, or Carousel. This is the selected asset type from the radio group.
   *
   * @memberof CanvasBuilder
   */
  getAsset = async (form, selectedAssetType) => {
    let isValid = false;
    switch (selectedAssetType.toLowerCase()) {
      case 'photo':
        isValid = await validateUrl(form.imageUrl, 'image');

        return isValid
          ? {
              type: form.radioGroup,
              radioFit: form.radioFit,
              name: form.photoName,
              url: form.imageUrl,
              imageTargetUrl: form.imageTargetUrl
            }
          : null;

      case 'video':
        isValid = await validateUrl(form.videoUrl, 'video');

        return isValid
          ? {
              type: form.radioGroup,
              name: form.videoName,
              radioFitVideo: form.radioFitVideo,
              url: form.videoUrl
            }
          : null;

      case 'carousel':
        isValid =
          (
            await Promise.all(
              form.cards.map((card) => validateUrl(card.cardImageUrl, 'image'))
            )
          ).filter((valid) => !valid).length === 0;

        return isValid
          ? {
              type: form.radioGroup,
              name: form.carouselName,
              radioFitCarousel: form.radioFitCarousel,
              cards: form.cards
            }
          : null;
      default:
        throw new Error('Unknown asset type has been selected.');
    }
  };

  cleanCanvasElements = async () => {
    const form = {
      canvasName: this.state.form.canvasName,
      theme: this.state.form.theme,
      headline: this.state.form.headline,
      copy: this.state.form.copy,
      radioGroup: 'Photo',
      radioFit: 'FitToWidth',
      radioFitVideo: 'FitToWidth',
      radioFitCarousel: 'FitToWidth',
      photoName: '',
      imageUrl: '',
      imageTargetUrl: '',
      videoName: '',
      videoUrl: '',
      carouselName: '',
      cards: [{ cardName: '', cardImageUrl: '', cardTargetUrl: '' }],
      tiles: this.state.form.tiles
    };

    await this.setState({ form });
    const elem = this.renderTabContent(0);
    const tabs = [{ menuItem: 1, pane: { key: '1', content: elem } }];
    this.setState({
      tabs,
      canvasElement: 'Photo',
      fit: 'FitToWidth',
      fitVideo: 'FitToWidth',
      fitCarousel: 'FitToWidth',
      nextTab: 2
    });
  };

  cleanForm = (notCleanElements) => {
    this.cleanCanvasElements();
    const form = this.state.form;
    form.canvasName = '';
    form.headline = '';
    form.copy = '';
    let canvasElements = [];

    if (notCleanElements) {
      canvasElements = this.state.canvasElements;
    }

    this.setState({ form, canvasElements });
  };

  addTab = (e) => {
    e.preventDefault();
    const tabs = this.state.tabs;
    const form = this.state.form;
    const nextCard = this.state.nextTab;
    form.cards.push({ cardName: '', cardImageUrl: '', cardTargetUrl: '' });
    this.setState({ form });
    const elem = this.renderTabContent(this.state.nextTab - 1);
    tabs.push({ menuItem: nextCard, pane: { key: nextCard, content: elem } });
    this.setState({ nextTab: this.state.nextTab + 1, tabs });
  };

  selectCanvasElement = (event, { name, value }) => {
    this.setState({
      canvasElement: value,
      form: { ...this.state.form, [name]: value }
    });
  };

  selectFit = (event, { name, value }) => {
    this.setState({ fit: value, form: { ...this.state.form, [name]: value } });
  };

  selectFitVideo = (event, { name, value }) => {
    this.setState({
      fitVideo: value,
      form: { ...this.state.form, [name]: value }
    });
  };

  selectFitCarousel = (event, { name, value }) => {
    this.setState({
      fitCarousel: value,
      form: { ...this.state.form, [name]: value }
    });
  };

  removeCanvasElements = async () => {
    this.state.canvasElementsToDelete.map(async (canvasId) => {
      if (canvasId) {
        const canvas = this.props.canvasToEdit.canvasElements.find(
          (item) => item.id === canvasId
        );

        switch (true) {
          case canvas.type === 'Photo':
            await this.deletePhoto(canvas.id);
            break;
          case canvas.type === 'Video':
            await this.deleteVideo(canvas.id);
            break;
          case canvas.type === 'Carousel':
            await this.deleteCarousel(canvas);
            break;
          default:
            break;
        }
      }
    });

    this.setState({ canvasElementsToDelete: [] });
  };

  saveDraft = (canvasId) => {
    const { user, saveCanvas, updateCanvas, saveToEdit } = this.props;
    const { email } = user;
    this.setState(
      {
        showPreventMessage: false,
        processing: true,
        operationResult: ''
      },
      async () => {
        const { form, log, canvasElements } = this.state;
        const { canvasName, theme, headline, copy, enableSwipe, tiles } = form;
        const finalEnableSwipe =
          enableSwipe !== null && enableSwipe !== undefined
            ? enableSwipe
            : true;
        const newLog = log;
        const canvas = {
          name: canvasName,
          theme,
          headline,
          copy,
          createdAt: new Date(),
          createdBy: email,
          updatedAt: new Date(),
          updatedBy: email,
          enableSwipe: finalEnableSwipe
        };
        let newCanvasId;

        try {
          if (canvasId) {
            canvas.id = canvasId;
            delete canvas.createdAt;
            delete canvas.createdBy;
            this.removeCanvasElements();
            const result = await updateCanvas(canvas);
            const resultCanvasId = result.data.updateCanvaById.canva.id;
            if (!resultCanvasId) {
              throw new Error('The canvas could not be updated.');
            }
            newLog.push(`Canvas: ${canvasName} was updated`);
            await this.updateTiles(canvasId);
          } else {
            const result = await saveCanvas(canvas);
            newCanvasId = result.data.createCanva.canva.id;
            if (!newCanvasId) {
              throw new Error('The new canvas could not be created.');
            }
            newLog.push(`Canvas: ${canvasName} was saved.`);
            await Promise.all(
              tiles.map(async (tile) => {
                if (tile.name || tile.asset || tile.image_url) {
                  await this.saveTile(tile, newCanvasId);
                }
              })
            );
          }

          await this.saveCanvasElements(
            canvasElements,
            canvasId || newCanvasId
          );
          saveToEdit(canvasId || newCanvasId);

          this.setState((prevState) => ({
            ...prevState,
            log: newLog,
            processing: false,
            operationResult: 'Canvas Processed Successfully'
          }));
        } catch (error) {
          newLog.push(
            `ERROR Canvas: ${canvasName} failed to be ${
              canvasId ? 'updated' : 'saved'
            }`
          );
          this.setState((prevState) => ({
            ...prevState,
            log: newLog,
            processing: false,
            operationResult: 'Canvas Processing Failed'
          }));
        }
      }
    );
  };

  updateTiles = async (editId) => {
    this.state.form.tiles.map(async (tile) => {
      if (!tile.id) {
        await this.saveTile(tile, editId);
      } else {
        await this.updateTile(tile, editId);
      }
    });

    this.props.canvasToEdit.tiles.map(async (tile) => {
      const existsTile = this.state.form.tiles.find(
        (item) => item.id === tile.id
      );
      if (!existsTile) {
        await this.props.deleteCanvasTile(tile.id);
      }
    });
  };

  handleSubmit = () => {
    this.setState(
      (prevState) => ({ ...prevState, log: [], errorMessage: '' }),
      () => {
        const { form, editId } = this.state;
        const { theme } = form || {};
        if (!theme) {
          this.setState((prevState) => ({
            ...prevState,
            errorMessage: 'Theme is required'
          }));
        } else {
          this.saveDraft(editId);
        }
      }
    );
  };

  saveCanvasElements = async (canvasElements, canvasId) => {
    await Promise.all(
      canvasElements.map(async (element, index) => {
        switch (true) {
          case element.type === 'Photo':
            if (element.id) {
              await this.updatePhoto(element, canvasId, index);
            } else {
              await this.savePhoto(element, canvasId, index);
            }
            return Promise.resolve(true);
          case element.type === 'Video':
            if (element.id) {
              await this.updateVideo(element, canvasId, index);
            } else {
              await this.saveVideo(element, canvasId, index);
            }
            return Promise.resolve(true);
          case element.type === 'Carousel':
            if (element.id) {
              await this.updateCarousel(element, canvasId, index);
            } else {
              await this.saveCarousel(element, canvasId, index);
            }
            return Promise.resolve(true);
          default:
            return Promise.resolve(false);
        }
      })
    );
  };

  updatePhoto = async (element, canvasId, index) => {
    const photo = {
      id: element.id,
      name: element.name,
      imageUrl: element.url,
      option: element.radioFit,
      targetUrl: element.imageTargetUrl,
      order: index,
      canvasId
    };

    const log = this.state.log;

    try {
      await this.props.updateCanvasPhoto(photo);
      log.push(`Photo: "${element.name}" was updated. `);
    } catch (error) {
      log.push(`ERROR Photo: "${element.name}" failed to be updated. `);
    }

    this.setState({ log });
  };

  savePhoto = async (element, newCanvasId, index) => {
    const photo = {
      name: element.name,
      imageUrl: element.url,
      option: element.radioFit,
      targetUrl: element.imageTargetUrl,
      canvasId: newCanvasId,
      order: index
    };

    const log = this.state.log;

    try {
      await this.props.saveCanvasPhoto(photo);
      log.push(`Photo: "${element.name}" was saved. `);
    } catch (error) {
      log.push(`ERROR Photo: "${element.name}" failed to be saved. `);
    }

    this.setState({ log });
  };

  updateVideo = async (element, canvasId, index) => {
    const video = {
      id: element.id,
      name: element.name,
      option: element.radioFitVideo,
      videoUrl: element.url,
      canvasId,
      order: index
    };

    const log = this.state.log;

    try {
      await this.props.updateCanvasVideo(video);
      log.push(`Video: "${element.name}" was updated. `);
    } catch (error) {
      log.push(`ERROR Video: "${element.name}" failed to be updated. `);
    }

    this.setState({ log });
  };

  saveVideo = async (element, newCanvasId, index) => {
    const video = {
      name: element.name,
      videoUrl: element.url,
      option: element.radioFitVideo,
      canvasId: newCanvasId,
      order: index
    };

    const log = this.state.log;

    try {
      await this.props.saveCanvasVideo(video);
      log.push(`Video: "${element.name}" was saved. `);
    } catch (error) {
      log.push(`ERROR Video: "${element.name}" failed to be saved. `);
    }

    this.setState({ log });
  };

  removeCards = async (updatedCarousel) => {
    const originalCarousel = this.props.canvasToEdit.canvasElements.find(
      (item) =>
        item.id === updatedCarousel.id && item.type === updatedCarousel.type
    );

    await Promise.all(
      originalCarousel.cards.map(async (card) => {
        const existsCard = updatedCarousel.cards.find(
          (item) => item.id === card.id
        );

        if (!existsCard) {
          await this.props.deleteCanvasCarouselCard(card.id);
        }
      })
    );
  };

  updateCarousel = async (element, canvasId, index) => {
    const updatedElement = element;
    await this.removeCards(updatedElement);

    const carousel = {
      id: updatedElement.id,
      name: updatedElement.name,
      option: updatedElement.radioFitCarousel,
      canvasId,
      order: index
    };

    const log = this.state.log;

    try {
      await this.props.updateCanvasCarousel(carousel);
      updatedElement.cards.forEach(async (card, indexCard) => {
        const carouselCard = {
          id: card.id,
          name: card.cardName,
          imageUrl: card.cardImageUrl,
          targetUrl: card.cardTargetUrl,
          carouselId: updatedElement.id
        };

        const result = card.id
          ? await this.props.updateCanvasCarouselCard(carouselCard)
          : await this.props.saveCanvasCarouselCard(carouselCard);

        if (!card.id) {
          updatedElement.cards[indexCard].id =
            result.data.createCanvasCarouselCard.canvasCarouselCard.id;
          updatedElement.cards[indexCard].carouselId = updatedElement.id;
          const originalCarousel = this.props.canvasToEdit.canvasElements.find(
            (item) =>
              item.id === updatedElement.id && item.type === updatedElement.type
          );
          originalCarousel.cards.push(updatedElement.cards[indexCard]);
        }
      });
      log.push(`Carousel: "${updatedElement.name}" was updated.`);
    } catch (error) {
      log.push(
        `ERROR Carousel: "${updatedElement.name}" failed to be updated.`
      );
    }

    this.setState({ log });
  };

  saveCarousel = async (element, newCanvasId, index) => {
    const carousel = {
      name: element.name,
      option: element.radioFitCarousel,
      canvasId: newCanvasId,
      order: index
    };

    const log = this.state.log;

    try {
      const result = await this.props.saveCanvasCarousel(carousel);
      const newCarouselId = result.data.createCanvasCarousel.canvasCarousel.id;
      // TODO: need to fix this await function so it runs each request synchronously
      // this is because the database incremental id of the carouselcard is used to determine "order"
      // this is very much a hack and we need to refactor and add a separate "order" column to track

      for (const card of element.cards) {
        const carouselCard = {
          name: card.cardName,
          imageUrl: card.cardImageUrl,
          targetUrl: card.cardTargetUrl,
          carouselId: newCarouselId
        };

        // TODO: this is bad, just needs to be done for above reasons ^^^^
        // eslint-disable-next-line no-await-in-loop
        await this.props.saveCanvasCarouselCard(carouselCard);
      }

      // TODO: the issue with this prior code is that it would trigger all the carousel card requets
      // at once, which can result with the database incremental id's not matching the expect card order
      // element.cards.map(async (card) => {
      //   const carouselCard = {
      //     name: card.cardName,
      //     imageUrl: card.cardImageUrl,
      //     targetUrl: card.cardTargetUrl,
      //     carouselId: newCarouselId
      //   };

      //   await this.props.saveCanvasCarouselCard(carouselCard);
      // });

      log.push(`Carousel: "${element.name}" was saved.`);
    } catch (error) {
      log.push(`ERROR Carousel: "${element.name}" failed to be saved.`);
    }

    this.setState({ log });
  };

  saveTile = async (element, newCanvasId) => {
    const tile = {
      name: element.name,
      asset: element.asset,
      imageUrl: element.image_url,
      canvasId: newCanvasId
    };

    const log = this.state.log;

    try {
      await this.props.saveCanvasTile(tile);
      log.push(`Tile: "${element.name}" was saved.`);
    } catch (error) {
      log.push(`ERROR Tile: "${element.name}" failed to be saved.`);
    }

    this.setState({ log });
  };

  updateTile = async (element, canvasId) => {
    const tile = {
      id: element.id,
      name: element.name,
      asset: element.asset,
      imageUrl: element.image_url,
      canvasId
    };

    const log = this.state.log;

    try {
      await this.props.updateCanvasTile(tile);
      log.push(`Tile: "${element.name}" was updated. `);
    } catch (error) {
      log.push(`ERROR Tile: "${element.name}" failed to be updated. `);
    }

    this.setState({ log });
  };

  handleSwipeToOpen = () => {
    const form = { ...this.state.form };
    form.enableSwipe = !form.enableSwipe;
    this.setState({ form, showPreventMessage: true });
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({
      form: { ...this.state.form, [name]: value },
      showPreventMessage: true
    });
  };

  onSelectAssetCard = (asset, name, cardNumber) => {
    const form = this.state.form;
    const card = form.cards[cardNumber - 1];

    let newFilename = asset.filename;
    const extension = newFilename.split('.').slice(-1);
    const guid = asset.guid;

    if (guid) {
      newFilename = `${guid}.${extension}`;
    }

    const fileUrl = buckets[window.location.hostname] + newFilename;
    card[name] = fileUrl;
    form.cards[cardNumber - 1] = card;
    this.setState({ form });
  };

  handleCardChange = (event, { name, value }) => {
    const cardNumber = event.target.id - 1;
    const form = this.state.form;
    const card = form.cards[cardNumber];
    card[name] = value;
    form.cards[cardNumber] = card;
    this.setState({ form });
  };

  handleTileChange = (event, { name, value }) => {
    const tileNumber = event.target.id;
    const form = this.state.form;
    const tile = form.tiles[tileNumber];
    tile[name] = value;
    form.tiles[tileNumber] = tile;
    this.setState({ form, showPreventMessage: true });
  };

  onCloseForm = (event) => {
    event.preventDefault();
    this.setState({ showModal: false });
  };

  onCloseModalPendingChanges = (event) => {
    event.preventDefault();
    this.setState({ showModalPendingChanges: false });
  };

  openColorPicker = (e) => {
    e.preventDefault();
    this.setState({ showModalColorPicker: true });
  };

  selectPage = (event, data) => {
    const selectedPage = find(data.options, (opt) => {
      return opt.value === data.value;
    });

    this.setState({
      selectedPage: selectedPage.value.pageId,
      selectedToken: selectedPage.value.access_token
    });
  };

  updateComponent = (component) => {
    const canvasElements = this.state.canvasElements;
    const canvasComponent = canvasElements.find(
      (canvas) => canvas.id === component.id && canvas.type === component.type
    );
    const index = this.state.canvasElements.indexOf(canvasComponent);
    canvasElements[index] = component;
    setTimeout(() => {
      this.setState({ canvasElements, showModal: false });
    }, 1000);
  };

  goBackSearch = () => {
    if (this.state.showPreventMessage) {
      this.setState({ showModalPendingChanges: true });
      return;
    }

    this.props.searchPage();
  };

  saveConfirm = async () => {
    this.setState({ showModalPendingChanges: false });
    const result = await this.handleSubmit();
    if (result) {
      setTimeout(() => {
        this.props.searchPage();
      }, 3000);
    }
  };

  deleteConfirm = () => {
    this.props.searchPage();
  };

  addTile = () => {
    const form = this.state.form;
    form.tiles.push({ name: '', asset: '', image_url: '' });
    this.setState({ form, showPreventMessage: true });
  };

  removeTile = (index) => {
    const form = this.state.form;
    form.tiles.splice(index, 1);
    this.setState({ form, showPreventMessage: true });
  };

  onSelectAsset = (asset, name) => {
    let filename = asset.filename;
    const extension = filename.split('.').slice(-1);
    const guid = asset.guid;

    if (guid) {
      filename = `${guid}.${extension}`;
    }

    const fileUrl = buckets[window.location.hostname] + filename;
    const form = this.state.form;
    form[name] = fileUrl;
    this.setState({ form });
  };

  onSelectTile = (asset, name, tileNumber) => {
    const form = this.state.form;
    const tile = form.tiles[tileNumber];
    tile.asset = asset.facebook_asset_id;
    tile.image_url = asset.video_thumbnail;
    form.tiles[tileNumber] = tile;
    this.setState({ form, showPreventMessage: true });
  };

  swapCanvasElement = (position, direction) => {
    const canvasElements = this.state.canvasElements;
    if (!this.props.canvasToEdit) {
      canvasElements.forEach((item, index) => {
        const updatedItem = item;
        updatedItem.order = index;
      });
    }
    const currentElem = canvasElements[position];

    if (direction === 'up') {
      currentElem.order = currentElem.order - 1;
      canvasElements[position - 1].order =
        canvasElements[position - 1].order + 1;
      canvasElements[position] = canvasElements[position - 1];
      canvasElements[position - 1] = currentElem;
    } else {
      currentElem.order = currentElem.order + 1;
      canvasElements[position + 1].order =
        canvasElements[position + 1].order - 1;
      canvasElements[position] = canvasElements[position + 1];
      canvasElements[position + 1] = currentElem;
    }

    this.setState({ canvasElements, showPreventMessage: true });
  };

  launchTest = async () => {
    const { editId } = this.state;
    const { launchCanvas } = this.props;
    toast(`Launching to test started. Please wait shortly for confirmation`, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 10000,
      type: toast.TYPE.INFO
    });
    try {
      const testPage = await this.getPagesTest();
      const { id, access_token } = testPage;
      const parameters = {
        canvasId: editId,
        pageId: id,
        token: access_token
      };
      launchCanvas(parameters);
    } catch (e) {
      toast(`Error obtaining test page ${e}`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 4000,
        type: toast.TYPE.ERROR
      });
    }
  };

  render() {
    const {
      canvasName,
      theme,
      photoName,
      imageTargetUrl,
      videoName,
      carouselName,
      enableSwipe
    } = this.state.form;
    return (
      <div>
        {this.state.processing ? (
          <Container>
            <Loader inline className="active" /> Processing...
          </Container>
        ) : null}
        {this.state.log.length > 0 ? (
          <div>
            <ul>
              {this.state.log.map((log) => {
                return <li>{log}</li>;
              })}
            </ul>
            <Divider hidden />
          </div>
        ) : null}
        {this.state.operationResult ? (
          <div>
            <span>
              <Icon size="large" name="check circle outline" />
              {this.state.operationResult}
            </span>
            <Divider hidden />
          </div>
        ) : null}
        {this.state.showPreventMessage ? (
          <div>
            <span className="prevent-message">
              Please save this draft in order to keep your changes. If you do
              not save, then your changes will be lost
            </span>
            <Divider hidden />
          </div>
        ) : null}
        <div className="canvas-container">
          <div className="back-link">
            <Button
              onClick={this.goBackSearch}
              size="small"
              disabled={this.state.processing}
              color="blue"
            >
              Back
            </Button>
          </div>
          <div className="save-draft-button">
            <Button
              onClick={this.handleSubmit}
              size="small"
              color="blue"
              disabled={!this.state.showPreventMessage}
            >
              Save Draft
            </Button>
          </div>
          <Divider hidden />
          <Form>
            <h2>Canvas</h2>
            <Form.Input
              className="input-name"
              placeholder="Canvas Name"
              type="text"
              name="canvasName"
              value={canvasName}
              onChange={this.handleFormChange}
            />
            <div className="color-picker-container">
              <Form.Input
                className="input-name"
                placeholder="Theme"
                type="text"
                name="theme"
                value={theme}
                onChange={this.handleFormChange}
              />
              <div
                className="color-picker-button"
                style={{ position: 'relative' }}
              >
                <Button
                  onClick={this.onOpenColorPicker}
                  size="small"
                  color="blue"
                >
                  Select Color
                </Button>

                {this.state.showModalColorPicker && (
                  <div style={{ position: 'absolute', zIndex: 5 }}>
                    <div
                      tabIndex={0}
                      role={'button'}
                      onClick={this.pickerClose}
                      style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0
                      }}
                    />
                    <ChromePicker color={theme} onChange={this.onColorChange} />
                  </div>
                )}
              </div>
            </div>
            <span className="swipe-to-open-label">Swipe to Open</span>
            <Checkbox
              toggle
              name="enableSwipe"
              onChange={this.handleSwipeToOpen}
              checked={enableSwipe}
            />
            {this.state.errorMessage ? (
              <div>
                <span className="prevent-message">
                  {this.state.errorMessage}
                </span>
                <Divider hidden />
              </div>
            ) : null}
            {/* <Modal
              dimmer={'inverted'}
              open={this.state.showModalColorPicker}
              onClose={this.onCloseFormColorPicker}
              size="small"
              className="modal-picker"
            >
              <Modal.Header>Select Color</Modal.Header>
              <Modal.Content>
                <ColorPicker
                  value={this.state.form.theme}
                  onDrag={this.onDrag.bind(this)}
                />
                <
                <div
                  style={{
                    background: this.state.form.theme,
                    width: 100,
                    height: 50,
                    color: 'white'
                  }}
                />
                {this.state.form.theme}
                <div className="modal-picker-button">
                  <Button
                    onClick={this.onCloseFormColorPicker}
                    size="small"
                    color="blue"
                  >
                    Select Color
                  </Button>
                </div>
              </Modal.Content>
            </Modal> */}
            <h2>Add Component</h2>
            <div className="warning">
              {this.state.canvasElement === 'Video'
                ? 'Video size cannot exceed 1GB, and must be .mp4'
                : 'Image size cannot exceed 4mb, and must be PNG, JPG, or JPEG'}
            </div>
            <div className="element-types">
              <span className="label-element-types">Element Type:</span>
              <Form.Radio
                label="Photo"
                name="radioGroup"
                value="Photo"
                className="canvas-radio"
                checked={this.state.canvasElement === 'Photo'}
                onChange={this.selectCanvasElement}
              />
              <Form.Radio
                label="Video"
                name="radioGroup"
                value="Video"
                className="canvas-radio"
                checked={this.state.canvasElement === 'Video'}
                onChange={this.selectCanvasElement}
              />
              <Form.Radio
                label="Carousel"
                name="radioGroup"
                value="Carousel"
                className="canvas-radio"
                checked={this.state.canvasElement === 'Carousel'}
                onChange={this.selectCanvasElement}
              />
            </div>
            {this.state.canvasElement === 'Photo' ? (
              <div>
                <div className="element-types">
                  <span className="label-element-types">Option:</span>
                  <Form.Radio
                    label="Fit To Width"
                    name="radioFit"
                    value="FitToWidth"
                    className="canvas-radio"
                    checked={this.state.fit === 'FitToWidth'}
                    onChange={this.selectFit}
                  />
                  <Form.Radio
                    label="Fit to Width Tappable"
                    name="radioFit"
                    value="FitToWidthTappable"
                    className="canvas-radio"
                    checked={this.state.fit === 'FitToWidthTappable'}
                    onChange={this.selectFit}
                  />
                  <Form.Radio
                    label="Fit To Height (Tilt)"
                    name="radioFit"
                    value="FitToHeight"
                    className="canvas-radio"
                    checked={this.state.fit === 'FitToHeight'}
                    onChange={this.selectFit}
                  />
                </div>
                <table className="table-image">
                  <tr>
                    <td className="column-image-fields">
                      <Form.Input
                        className="input-image input-name"
                        placeholder="Photo Name"
                        type="text"
                        name="photoName"
                        value={photoName}
                        onChange={this.handleFormChange}
                      />
                      <div className="asset-gallery-container">
                        <AssetGallery
                          getFbToken={this.props.getFbToken}
                          onAssetSelected={(asset) =>
                            this.onSelectAsset(asset, 'imageUrl')
                          }
                          assetType="image"
                          previewFileUrl={this.state.form.imageUrl}
                        />
                      </div>
                      <Form.Input
                        className="input-image input-name"
                        placeholder="Target Url"
                        type="text"
                        name="imageTargetUrl"
                        value={imageTargetUrl}
                        onChange={this.handleFormChange}
                      />
                    </td>
                  </tr>
                </table>
              </div>
            ) : null}
            {this.state.canvasElement === 'Video' ? (
              <div>
                <div className="element-types">
                  <span className="label-element-types">Option:</span>
                  <Form.Radio
                    label="Fit To Width"
                    name="radioFitVideo"
                    value="FitToWidth"
                    className="canvas-radio"
                    checked={this.state.fitVideo === 'FitToWidth'}
                    onChange={this.selectFitVideo}
                  />
                  <Form.Radio
                    label="Fit To Height (Tilt)"
                    name="radioFitVideo"
                    value="FitToHeight"
                    className="canvas-radio"
                    checked={this.state.fitVideo === 'FitToHeight'}
                    onChange={this.selectFitVideo}
                  />
                </div>
                <Form.Input
                  className="input-name"
                  placeholder="Video Name"
                  type="text"
                  name="videoName"
                  value={videoName}
                  onChange={this.handleFormChange}
                />
                <div className="asset-gallery-container">
                  <AssetGallery
                    getFbToken={this.props.getFbToken}
                    onAssetSelected={(asset) =>
                      this.onSelectAsset(asset, 'videoUrl')
                    }
                    assetType="video"
                    previewFileUrl={this.state.form.videoUrl}
                  />
                </div>
              </div>
            ) : null}
            {this.state.canvasElement === 'Carousel' ? (
              <div className="container-cards">
                <div className="element-types">
                  <span className="label-element-types">Option:</span>
                  <Form.Radio
                    label="Fit To Width"
                    name="radioFitCarousel"
                    value="FitToWidth"
                    className="canvas-radio"
                    checked={this.state.fitCarousel === 'FitToWidth'}
                    onChange={this.selectFitCarousel}
                  />
                  <Form.Radio
                    label="Fit To Height (Tilt)"
                    name="radioFitCarousel"
                    value="FitToHeight"
                    className="canvas-radio"
                    checked={this.state.fitCarousel === 'FitToHeight'}
                    onChange={this.selectFitCarousel}
                  />
                </div>
                <Form.Input
                  className="input-name"
                  placeholder="Carousel Name"
                  type="text"
                  name="carouselName"
                  value={carouselName}
                  onChange={this.handleFormChange}
                />
                <Button
                  onClick={this.addTab}
                  disabled={this.state.nextTab > 10}
                  size="small"
                  color="blue"
                >
                  Add Card
                </Button>
                <Button
                  onClick={this.removeLastCard}
                  disabled={this.state.nextTab === 2}
                  size="small"
                  color="blue"
                >
                  Remove Card
                </Button>
                <Divider hidden />
                <Tab
                  onTabChange={this.selectedTab}
                  activeIndex={this.state.activeIndex}
                  panes={this.state.tabs}
                  renderActiveOnly={false}
                />
                <Divider hidden />
              </div>
            ) : null}
            <div className="message">{this.state.componentMessage}</div>
            <Button onClick={this.addComponent} size="small" color="blue">
              Add Component
            </Button>
            <Divider hidden />
          </Form>
        </div>
        <div className="tiles-container">
          <h2>Marketing Tiles</h2>
          {this.state.form.tiles.map((tile, index) => {
            return (
              <CanvasTile
                getFbToken={this.props.getFbToken}
                tileNumber={index}
                handleTileChange={this.handleTileChange}
                onSelectTile={this.onSelectTile}
                tile={this.state.form.tiles[index]}
                removeTile={this.removeTile}
              />
            );
          })}
          <a
            role="button"
            tabIndex={0}
            className="icon-trash"
            onClick={this.addTile}
          >
            <Icon size="large" name="plus circle" />
          </a>
          New
        </div>
        <div className="canvas-container-list">
          {!this.validateLastElementImage() ? (
            <div>
              <span className="prevent-message">
                The last element in the canvas is not an image
              </span>
            </div>
          ) : null}
          <h2>Preview</h2>
          <PreviewList
            canvasElements={this.state.canvasElements}
            editCanvasElement={this.editCanvasElement}
            deleteCanvasElement={this.deleteCanvasElement}
            showPreventMessage={this.showPreventMessage}
            swapCanvasElement={this.swapCanvasElement}
          />
          <div>
            <TextArea
              className="textarea-field"
              placeholder="Headline"
              name="headline"
              rows="5"
              value={this.state.form.headline}
              onChange={this.handleFormChange}
            />
            <TextArea
              className="textarea-field"
              placeholder="Copy"
              name="copy"
              rows="5"
              value={this.state.form.copy}
              onChange={this.handleFormChange}
            />
          </div>
          <Button onClick={this.launchTest} size="small" color="blue">
            Launch Test
          </Button>
          <Divider hidden />
        </div>
        <Modal
          dimmer={'inverted'}
          open={this.state.showModal}
          onClose={this.onCloseForm}
          closeOnDimmerClick={false}
        >
          <Modal.Header>Edit Component</Modal.Header>
          <Modal.Content>
            <ModalForm
              id={this.state.canvasComponentId}
              type={this.state.canvasComponentType}
              componentToEdit={this.state.componentToEdit}
              updateComponent={this.updateComponent}
              showPreventMessage={this.showPreventMessage}
              getFbToken={this.props.getFbToken}
              onCloseForm={this.onCloseForm}
            />
          </Modal.Content>
        </Modal>

        <Modal
          dimmer={'inverted'}
          open={this.state.showModalPendingChanges}
          onClose={this.onCloseModalPendingChanges}
          className="prevent-modal"
        >
          <Modal.Header>Pending Changes</Modal.Header>
          <Modal.Content>
            <h3>Would you like to save your changes?</h3>
            <Button onClick={this.saveConfirm} size="small" color="blue">
              Save
            </Button>
            <Button onClick={this.deleteConfirm} size="small" color="red">
              Discard
            </Button>
            <Button
              onClick={this.onCloseModalPendingChanges}
              size="small"
              color="grey"
            >
              Cancel
            </Button>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const submitCanvas = gql`
  mutation($canva: CanvaInput!) {
    createCanva(input: { canva: $canva }) {
      canva {
        id
        name
        theme
        headline
        copy
        createdAt
        createdBy
        updatedAt
        updatedBy
        enableSwipe
      }
    }
  }
`;

const submitCanvasPhoto = gql`
  mutation($canvasPhoto: CanvasPhotoInput!) {
    createCanvasPhoto(input: { canvasPhoto: $canvasPhoto }) {
      canvasPhoto {
        id
        name
        imageUrl
        option
        targetUrl
        canvasId
        order
      }
    }
  }
`;

const submitCanvasVideo = gql`
  mutation($canvasVideo: CanvasVideoInput!) {
    createCanvasVideo(input: { canvasVideo: $canvasVideo }) {
      canvasVideo {
        id
        name
        option
        videoUrl
        canvasId
        order
      }
    }
  }
`;

const submitCanvasCarousel = gql`
  mutation($canvasCarousel: CanvasCarouselInput!) {
    createCanvasCarousel(input: { canvasCarousel: $canvasCarousel }) {
      canvasCarousel {
        id
        name
        option
        canvasId
        order
      }
    }
  }
`;

const submitCanvasCarouselCard = gql`
  mutation($canvasCarouselCard: CanvasCarouselCardInput!) {
    createCanvasCarouselCard(
      input: { canvasCarouselCard: $canvasCarouselCard }
    ) {
      canvasCarouselCard {
        id
        name
        imageUrl
        targetUrl
        carouselId
      }
    }
  }
`;

const submitCanvasTile = gql`
  mutation($canvasTile: CanvasTileInput!) {
    createCanvasTile(input: { canvasTile: $canvasTile }) {
      canvasTile {
        id
        name
        asset
        imageUrl
        canvasId
      }
    }
  }
`;

const updateCanvas = gql`
  mutation($id: Int!, $canva: CanvaPatch!) {
    updateCanvaById(input: { id: $id, canvaPatch: $canva }) {
      canva {
        id
        name
        theme
        headline
        copy
        updatedAt
        updatedBy
        enableSwipe
      }
    }
  }
`;

const updateCanvasPhoto = gql`
  mutation($id: Int!, $canvasPhoto: CanvasPhotoPatch!) {
    updateCanvasPhotoById(input: { id: $id, canvasPhotoPatch: $canvasPhoto }) {
      canvasPhoto {
        name
        imageUrl
        option
        targetUrl
        order
      }
    }
  }
`;

const updateCanvasVideo = gql`
  mutation($id: Int!, $canvasVideo: CanvasVideoPatch!) {
    updateCanvasVideoById(input: { id: $id, canvasVideoPatch: $canvasVideo }) {
      canvasVideo {
        name
        option
        videoUrl
        order
      }
    }
  }
`;

const updateCanvasCarousel = gql`
  mutation($id: Int!, $canvasCarousel: CanvasCarouselPatch!) {
    updateCanvasCarouselById(
      input: { id: $id, canvasCarouselPatch: $canvasCarousel }
    ) {
      canvasCarousel {
        name
        option
        order
      }
    }
  }
`;

const updateCanvasCarouselCard = gql`
  mutation($id: Int!, $canvasCarouselCard: CanvasCarouselCardPatch!) {
    updateCanvasCarouselCardById(
      input: { id: $id, canvasCarouselCardPatch: $canvasCarouselCard }
    ) {
      canvasCarouselCard {
        name
        imageUrl
        targetUrl
      }
    }
  }
`;

const updateCanvasTile = gql`
  mutation($id: Int!, $canvasTile: CanvasTilePatch!) {
    updateCanvasTileById(input: { id: $id, canvasTilePatch: $canvasTile }) {
      canvasTile {
        name
        asset
        imageUrl
        canvasId
      }
    }
  }
`;

const deleteCanvasPhoto = gql`
  mutation($id: Int!) {
    deleteCanvasPhotoById(input: { id: $id }) {
      canvasPhoto {
        id
        name
        imageUrl
        option
        targetUrl
        canvasId
        order
      }
    }
  }
`;

const deleteCanvasVideo = gql`
  mutation($id: Int!) {
    deleteCanvasVideoById(input: { id: $id }) {
      canvasVideo {
        id
        name
        option
        videoUrl
        canvasId
        order
      }
    }
  }
`;

const deleteCanvasCarousel = gql`
  mutation($id: Int!) {
    deleteCanvasCarouselById(input: { id: $id }) {
      canvasCarousel {
        id
        name
        option
        canvasId
        order
      }
    }
  }
`;

const deleteCanvasCarouselCard = gql`
  mutation($id: Int!) {
    deleteCanvasCarouselCardById(input: { id: $id }) {
      canvasCarouselCard {
        id
        name
        imageUrl
        targetUrl
        carouselId
      }
    }
  }
`;

const deleteCanvasTile = gql`
  mutation($id: Int!) {
    deleteCanvasTileById(input: { id: $id }) {
      canvasTile {
        id
        name
        asset
        imageUrl
        canvasId
      }
    }
  }
`;

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const CanvasBuilderWithData = compose(
  graphql(submitCanvas, {
    props: ({ mutate }) => ({
      saveCanvas: (canva) => mutate({ variables: { canva } })
    })
  }),
  graphql(submitCanvasPhoto, {
    props: ({ mutate }) => ({
      saveCanvasPhoto: (canvasPhoto) => mutate({ variables: { canvasPhoto } })
    })
  }),
  graphql(submitCanvasVideo, {
    props: ({ mutate }) => ({
      saveCanvasVideo: (canvasVideo) => mutate({ variables: { canvasVideo } })
    })
  }),
  graphql(submitCanvasCarousel, {
    props: ({ mutate }) => ({
      saveCanvasCarousel: (canvasCarousel) =>
        mutate({ variables: { canvasCarousel } })
    })
  }),
  graphql(submitCanvasCarouselCard, {
    props: ({ mutate }) => ({
      saveCanvasCarouselCard: (canvasCarouselCard) =>
        mutate({ variables: { canvasCarouselCard } })
    })
  }),
  graphql(submitCanvasTile, {
    props: ({ mutate }) => ({
      saveCanvasTile: (canvasTile) => mutate({ variables: { canvasTile } })
    })
  }),
  graphql(updateCanvas, {
    props: ({ mutate }) => ({
      updateCanvas: (canvas) =>
        mutate({
          variables: {
            id: canvas.id,
            canva: omit(canvas, ['id', 'createdAt', 'createdBy', '__typename'])
          }
        })
    })
  }),
  graphql(updateCanvasPhoto, {
    props: ({ mutate }) => ({
      updateCanvasPhoto: (canvasPhoto) =>
        mutate({
          variables: {
            id: canvasPhoto.id,
            canvasPhoto: omit(canvasPhoto, ['id', 'canvasId'])
          }
        })
    })
  }),
  graphql(updateCanvasTile, {
    props: ({ mutate }) => ({
      updateCanvasTile: (canvasTile) =>
        mutate({
          variables: {
            id: canvasTile.id,
            canvasTile: omit(canvasTile, ['id', 'canvasId'])
          }
        })
    })
  }),
  graphql(updateCanvasVideo, {
    props: ({ mutate }) => ({
      updateCanvasVideo: (canvasVideo) =>
        mutate({
          variables: {
            id: canvasVideo.id,
            canvasVideo: omit(canvasVideo, ['id', 'canvasId'])
          }
        })
    })
  }),
  graphql(updateCanvasCarousel, {
    props: ({ mutate }) => ({
      updateCanvasCarousel: (canvasCarousel) =>
        mutate({
          variables: {
            id: canvasCarousel.id,
            canvasCarousel: omit(canvasCarousel, ['id', 'canvasId'])
          }
        })
    })
  }),
  graphql(updateCanvasCarouselCard, {
    props: ({ mutate }) => ({
      updateCanvasCarouselCard: (canvasCarouselCard) =>
        mutate({
          variables: {
            id: canvasCarouselCard.id,
            canvasCarouselCard: omit(canvasCarouselCard, ['id', 'carouselId'])
          }
        })
    })
  }),
  graphql(deleteCanvasPhoto, {
    props: ({ mutate }) => ({
      deleteCanvasPhoto: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasVideo, {
    props: ({ mutate }) => ({
      deleteCanvasVideo: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasCarousel, {
    props: ({ mutate }) => ({
      deleteCanvasCarousel: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasTile, {
    props: ({ mutate }) => ({
      deleteCanvasTile: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasCarouselCard, {
    props: ({ mutate }) => ({
      deleteCanvasCarouselCard: (id) =>
        mutate({
          variables: { id }
        })
    })
  })
)(CanvasBuilder);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CanvasBuilderWithData);



// WEBPACK FOOTER //
// ./src/screens/Canvas/CanvasBuilder.js